module.exports = __webpack_public_path__ + "img/wx.79a1de7e.png";